"use client";
import { Open_Sans } from 'next/font/google'
import FormatSiteFooter from "@/components/client/SiteFooter/FormatSiteFooter";
import FormatGlobalFooter from "@/components/client/GlobalFooter/FormatGlobalFooter";
import FormatSiteNavigation from "@/components/client/SiteNavigation/FormatSiteNavigation";
import useLanguage from "../Hooks/useLanguage";
import Providers from '@/components/Providers';
import Script from 'next/script';
import { RouteTracker } from '../RouteTracker/RouteTracker';
import { GoogleTagManager } from '@next/third-parties/google'
import SkipToContent from '../SkipToContent/SkipToContent';

const openSans = Open_Sans({
  subsets: ['latin'],
  display: 'swap',
})

const LayoutComponent = ({ profile, navData, siteFooterData, footerData, lang, config, children, siteLangs, displayActionBlock = false } : 
  { 
    profile: any, 
    navData: any, 
    siteFooterData: any, 
    footerData: any, 
    lang: string, 
    config: any, 
    children: React.ReactNode,
    siteLangs: any[],
    displayActionBlock?: boolean 
  }
) => {
  const siteNavPack = {
    data: navData,
    profile: profile,
    config: config,
  }

  const pageLocation = (typeof window !== "undefined") ? window?.location : null;

  // enabling this breaks Preview, because the language shouldn't be changed and this code changes the URL.
  // and because this is a hook, it can't be conditionally rendered.

  const { languageSettings, saveLanguageSettings } = useLanguage(
    pageLocation,
    siteLangs,
    profile
  )

  return (
    <html lang={lang} className={openSans.className}>
      { profile?.NEXT_PUBLIC_GTM_DISABLE !== true &&
        <GoogleTagManager gtmId={profile?.NEXT_PUBLIC_GTM_ID} />
      }
      <body>
        {/* One Trust */}
        { profile?.NEXT_PUBLIC_ONETRUST_DISABLE !== true &&
          <Script
            src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
            rel="preconnect"
            type="text/javascript" 
            data-domain-script={profile?.NEXT_PUBLIC_ONETRUST_ID} />
        }
        { profile?.NEXT_PUBLIC_ONETRUST_DISABLE !== true &&
          <Script
            id="optanon"
            type="text/javascript" 
            dangerouslySetInnerHTML={{
              __html: `function OptanonWrapper() { }`,
            }}
          />
        }
        <SkipToContent />
        <section className="min-h-screen">
          {profile?.NEXT_PUBLIC_RENDER_NAV && config !== undefined && <FormatSiteNavigation {...siteNavPack} 
            languageSettings={languageSettings} 
            saveLanguageSettings={saveLanguageSettings} 
            siteLangs={siteLangs}
          />}
          <main id="page-content">
          <Providers params={{lang: lang}}>
            <RouteTracker />
            {children}
          </Providers>
          </main>
          {displayActionBlock && (<div className="action-block-spacer"></div>)}
          {profile?.NEXT_PUBLIC_RENDER_FOOTER && config !== undefined && <FormatSiteFooter data={siteFooterData} /> }
          {profile?.NEXT_PUBLIC_RENDER_FOOTER && config !== undefined && <FormatGlobalFooter data={footerData} /> }
        </section>
      </body>
    </html>
  )
}

export default LayoutComponent